import { AccountVerifyPhoneCode } from '@bz/account';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    dialog: {
      get title() {
        return t('Phone number verification');
      },
      //   class: 'w-[860px] h-[700px]'
    },
  },
};

export default AccountVerifyPhoneCode;
